export const WECHAT_OPENLINK =
  "https://game.weixin.qq.com/cgi-bin/comm/openlink?noticeid=90228163&appid=wx95a3a4d7c627e07d&url=https%3A%2F%2Fpay.qq.com%2Fh5%2Factivity%2Fbargain%2Fwzry.php%3Fpf%3D__mds_wzry_client.login"
export const GAME_URL = "//pvp.qq.com/act/a20190121apk/index.html"
export const RECHARGE_URL = "//pay.qq.com/h5/shop.shtml?pf=__mds_bargain_activity.wzry#/order/2/biz/2"
export const LUCKY_DRAW_URL = "https://pay.qq.com/h5/active/wzry_lottery.php?key=wzry_lottery201907&pf=__mds_wzry_bargain.lottery"
export const VMALL_URL = "https://pay.qq.com/h5/active/store_wzry_daoju.shtml?game=wzry&pf=__mds_wzry.bargain.list"
export const RECOMMEND_MODEL = "wzry_bargain_recomm_v3"
export const GUESS_YOU_LIKE = "wzry_bargain_recomm_help_v3"
export const REPORT = {
  PAGEVIEW: {
    HOMEPAGE: "pageview.bargain_wxry.homepage", //首页曝光
    //首页砍价物品获取成功
    BARGAIN_PRODUCTS_SUCCESS: "pageview.bargain_wxry.bargain_products",
    RULE: "pageview.bargain_wxry.rule", //活动规则展示
    OPENER_PROMPT: "pageview.bargain_wxry.starter_invite_popup", //砍价商品页-发起人-发起弹窗
    CHANGE_ZONE: "pageview.bargain_wxry.login", //切换帐号信息弹窗
    OPENER_BARGAIN_PROGRESSING: "pageview.bargain_wxry.process", //砍价进度页-发起人-进行中
    HELPER_BARGAIN_PROGRESSING: "pageview.bargain_wxry.process_assistor", //砍价进度页-帮砍人
    OPENER_BARGAIN_END: "pageview.bargain_wxry.end", //砍价进度页-发起人-已结束
    HELPER_BARGAIN_END: "pageview.bargain_wxry.assistor_activityend", //砍价进度页-帮砍人-小砍结束
    HELP_BARGAIN_SUCCESS: "pageview.bargain_wxry.assitor_toast", //帮砍成功
    EXCEED_HELP_BARGAIN_MAXMUM: "pageview.bargain_wxry.restrict_assistor_exceed", //限制提示-帮砍人-超过总帮砍次数

    // 砍价首页-暴击弹窗
    OPENER_BAOJI_POPUP: "pageview.bargain_wxry.starter_bao_popup",
    // 砍价进度页-帮砍人-暴击弹窗
    HELPER_BAOJI_POPUP: "pageview.bargain_wxry.assitor_bao_popup",

    //    开砍人购买成功
    BUY_SUCCESS: "pageview.bargain_wxry.buy_success",
    //开砍人购买失败
    BUY_FAILURE: "pageview.bargain_wxry.buy_failure",
    //限制提示-总活动已结束
    ACTIVITY_END: "pageview.bargain_wxry.restrict_end",
    //登录提示-选择QQ/微信进入活动
    ENTER_OUTSIDE_OF_GAME_OR_WECHAT_OR_QQ: "pageview.bargain_wxry.restrict_choose",
    //砍价进度页-帮砍人-失败弹窗
    HELP_BARGAIN_FAILURE: "pageview.bargain_wxry.assitor_failure",
    //排队上报
    BUSY_QUEUE: "pageview.bargain_wxry.busy_queue",
    USER_HAS_ITEM: "pageview.bargain_wxry.hasitem",
    BARGAIN_DETAIL_ERROR: "pageview.bargain_wxry.bargain_detail.error",
    BARGAIN_HELPER_ZONE_ROLE_ERROR: "pageview.bargain_wxry.bargain_helper.zonerole.error",

    //用户支付时候系统和发起砍价不一致
    USER_OS_NOT_MATCH: "pageview.bargain_wxry.user_os_not_match",
    //用户支付时候大区和发起时候不一致
    USER_PARTITION_NOT_MATCH: "pageview.bargain_wxry.user_partition_not_match"
  },
  CLICK: {
    //选择大区角色
    CHOOSE_ZONE: "click.bargain_wxry.login",
    //点击活动规则
    SHOW_RULE: "click.bargain_wxry.rule",
    //发起砍价按钮
    START_BARGAIN: "click.bargain_wxry.start",
    //限制提醒-开砍失败,
    START_BARGAIN_FAILURE: "click.bargain_wxry.restrict_fail",

    //微信内分享
    SHARE_BARGAIN_IN_WECHAT: "click.bargain_wzxy.price_wxshare",
    //QQ内分享
    SHARE_BARGAIN_IN_QQ: "click.bargain_wzxy.price_sqshare",
    //QQ内分享成功
    SHARE_BARGAIN_IN_QQ_SUCCESS: "click.bargain_wzxy.price_sqshare_success",
    //QQ内用户取消分享
    SHARE_BARGAIN_IN_QQ_FAILURE: "click.bargain_wzxy.price_sqshare_failure",
    //发起砍价，请好友帮看
    START_BARGAIN_THEN_INVITE_FRIENDS: "click.bargain_wxry.price_invite",
    //发起砍价弹窗邀请好友,关闭按钮
    START_BARGAIN_THEN_CLOSE_DIALOG: "click.bargain_wxry.price_close",

    //发起人-首页-查看进度
    VIEW_BARGAIN_DETAIL: "click.bargain_wxry.check",
    //发起人-小砍已结束-首页点击立即拥有
    INDEX_BARGAIN_BUY_NOW: "click.bargain_wxry.starter_end_get",

    //砍价详情页面,邀请好友
    BARGAIN_DETAIL_INVITE_FRIENDS: "click.bargain_wxry.starter_process_invite",

    //发起人-小砍已结束-进度页点立即拥有
    BARGAIN_DETAIL_END_BUY: "click.bargain_wxry.starter_end_now",
    //砍价进度页面-未结束-立即拥有
    BARGAIN_DETAIL_ONGOING_BUY: "click.bargain_wxry.starter_process_now",
    // 发起人-支付-其他方式支付
    OWNER_PAY_OTHER_WAY: "click.bargain_wxry.starter_get_cash",
    // 发起人-支付-点券支付
    OWNER_PAY_GAMECOIN: "click.bargain_wxry.starter_get_dianquan",

    OPENER_BAOJI_VIEW_DETAIL: "click.bargain_wxry.starter_baoji_view",

    //    帮砍人-帮砍页面-商品推荐
    BARGAIN_HELPER_RECOMMEND: "click.price.assistor_help_recommand",
    //帮砍人-帮砍页面-帮砍一刀
    HELP_BARGAIN: "click.bargain_wxry.assistor_help",
    //帮砍人-帮砍页面-我也要发起砍价
    HELPER_WANT_BARGAIN: "click.bargain_wxry.assistor_start",
    //帮砍人-帮砍页面-去抽奖
    HELPER_WANT_LUCKY_DRAW: "click.bargain_wxry.assistor_lucky",

    //发起人-支付结果页-进入游戏
    SUCCESS_BARGAIN_ENTER_GAME: "click.price.starter_pay_enter",
    //发起人-支付结果页-再砍一个
    SUCCESS_BARGAIN_AGAIN: "click.price.starter_pay_again",

    //游戏内页面-分享-微信朋友圈
    INGAME_SHARE_TIMELINE: "click.bargain_wxry.ingame_share_moment",
    //游戏内页面-分享-微信
    INGAME_SHARE_WECHAT: "click.bargain_wxry.ingame_share_wechat",
    //游戏内页面-分享-QQ
    INGAME_SHARE_QQ: "click.bargain_wxry.ingame_share_qq",
    //游戏内页面-分享-QQ空间
    INGAME_SHARE_QZONE: "click.bargain_wxry.ingame_share_qqzone",

    //发起人-砍价进度-去抽时间礼包
    BARGAIN_STARTER_LUCK_DRAW: "click.bargain_wxry.starter_lottery",
    GOODS_LEFT: "click.bargain_wxry.goods_left", //发起人-首页-左翻页
    GOODS_RIGHT: "click.bargain_wxry.goods_right", //发起人-首页-右翻页

    LIST_SKIN: "click.bargain_wxry.list_skin", //	发起人-首页-皮肤分类导航
    LIST_HERO: "click.bargain_wxry.list_hero", //	发起人-首页-英雄分类导航
    LIST_STARSKIN: "click.bargain_wxry.list_xingyuan", //	发起人-首页-星元部件分类导航

    RECOMMEND_BACK_INDEX: "click.price.assistor_help_recommandcheck", //	帮砍人-帮砍页面-查看商品推荐（回到首页）

    HELP_BARGAIN_SUCCESS_RECEIVE_GIFT: "click.bargain_wxry.assistor_help_get", //	帮砍人-帮砍页面-帮砍成功领取礼包

    HELP_BARGAIN_SUCCESS_RECEIVE_GIFT_SUCCESS: "click.bargain_wxry.assistor_help_get_success", //	帮砍人-帮砍页面-帮砍成功领取礼包成功
    HELP_BARGAIN_SUCCESS_RECEIVE_GIFT_ERROR: "click.bargain_wxry.assistor_help_get_error" //	帮砍人-帮砍页面-帮砍成功领取礼包失败
  }
}

export const ACTIVITY = {
  "1450019044": "KANJ190701161932880",
  "1450019173": "KANJ190327174753282"
}

export const SEND_QUALIFICATION_OFFERID = "1450019044"

export const SEND_QUALIFICATION_GROUPID = {
  OPEN: "TXCZ190327160146520", //发起砍价
  HELP: "TXCZ190711224011739" //帮砍
}

export const SHARE_DETAIL = {
  INDEX_TITLE: "全峡谷召唤师们都在砍！砍多少省多少！",
  INDEX_DESC: "凯-龙域领主、百里玄策-威尼斯狂欢、王昭君-精灵公主……集合！准备开砍！",
  OPEN_TITLE: "帮我砍一刀！王者荣耀勇者皮肤限时5折啦！",
  OPEN_DESC: "砍价活动，限时重燃！帮砍免费领礼包～",
  ICON: "https://midas.gtimg.cn/h5/bargain/static/images/wzry_bargain_share.png",
  INGAME_BASE64_ICON:
    "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"
}

export const PRODUCTS = [
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926096",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "李元芳",
    product_url: "https://midas.gtimg.cn/store_config/1561968041337gXj6RlrN.jpg",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926093",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "诸葛亮",
    product_url: "https://midas.gtimg.cn/store_config/1561967739410LvNxWtVF.jpg",
    product_type: "",
    origin_amt: 6880,
    least_amt: 2060,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926095",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "貂蝉",
    product_url: "https://midas.gtimg.cn/store_config/1561967931915orQDDe3w.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926097",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "露娜",
    product_url: "https://midas.gtimg.cn/store_config/1562815742997CHy1lQms.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926098",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "王昭君",
    product_url: "https://midas.gtimg.cn/store_config/1562815732232tO8VLXuj.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926100",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "苏烈",
    product_url: "https://midas.gtimg.cn/store_config/1562815722532otag8qd.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926101",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "高渐离",
    product_url: "https://midas.gtimg.cn/store_config/1562815713970QdQ1YRi1.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926103",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "鬼谷子",
    product_url: "https://midas.gtimg.cn/store_config/1562815703863UuJGnl0y.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926105",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "黄忠",
    product_url: "https://midas.gtimg.cn/store_config/1562815693235hBaBGhRq.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926109",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "百里玄策",
    product_url: "https://midas.gtimg.cn/store_config/1562815683386bM38x8NU.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926111",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "达摩",
    product_url: "https://midas.gtimg.cn/store_config/1562815667643YNvo4JT4.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926112",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "后羿-阿尔法小队",
    product_url: "https://midas.gtimg.cn/store_config/1561968169661TBR5VK8S.jpg",
    product_type: "",
    origin_amt: 4880,
    least_amt: 2440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926114",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "貂蝉-异域舞娘",
    product_url: "https://midas.gtimg.cn/store_config/1561968265846q2TKZ5ag.jpg",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926117",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "露娜-绯红之刃",
    product_url: "https://midas.gtimg.cn/store_config/1561968355098xWwKIEVZ.jpg",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926119",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "芈月-红桃皇后",
    product_url: "https://midas.gtimg.cn/store_config/1562815901925VC2xl3gt.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926123",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "王昭君-精灵公主",
    product_url: "https://midas.gtimg.cn/store_config/1562815914810dfPrrZet.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926127",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "典韦-黄金武士",
    product_url: "https://midas.gtimg.cn/store_config/1562815926965RNk1lXh.png",
    product_type: "",
    origin_amt: 8880,
    least_amt: 4440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926141",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "甄姬-冰雪圆舞曲",
    product_url: "https://midas.gtimg.cn/store_config/1562815936972DIOxVZrG.png",
    product_type: "",
    origin_amt: 8880,
    least_amt: 4440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926143",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "宫本武藏-万象初新",
    product_url: "https://midas.gtimg.cn/store_config/1562815946252wrYlA2W.png",
    product_type: "",
    origin_amt: 4880,
    least_amt: 2440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926144",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "苏烈-爱与和平",
    product_url: "https://midas.gtimg.cn/store_config/1562815960523DNdE6OkU.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926177",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "高渐离-金属狂潮",
    product_url: "https://midas.gtimg.cn/store_config/1562815973809Abp8VUgh.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926180",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "鬼谷子-阿摩司公爵",
    product_url: "https://midas.gtimg.cn/store_config/1562815985222IsHIz60u.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926183",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "裴擒虎-街头旋风",
    product_url: "https://midas.gtimg.cn/store_config/1562816000589KRxOUMSV.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926186",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "鲁班七号-木偶奇遇记",
    product_url: "https://midas.gtimg.cn/store_config/156281600948331Bkfw.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926188",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "黄忠-芝加哥教父",
    product_url: "https://midas.gtimg.cn/store_config/1562816020139ylAtIfXv.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926190",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "达摩-大发明家",
    product_url: "https://midas.gtimg.cn/store_config/1562816032955bhjIipdK.png",
    product_type: "",
    origin_amt: 4880,
    least_amt: 2440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926192",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "百里玄策-威尼斯狂欢",
    product_url: "https://midas.gtimg.cn/store_config/1562816052931MkltBla.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926199",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "赵云-忍·炎影",
    product_url: "https://midas.gtimg.cn/store_config/1562816288706dzS94YPf.png",
    product_type: "",
    origin_amt: 8880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926202",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "紫金岁月·礼帽",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/c12d48f5a487d83bc8bd9a3408c4f029.png",
    product_type: "",
    origin_amt: 300,
    least_amt: 180,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926206",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "哥特少女·礼帽",
    product_url: "https://midas.gtimg.cn/store_config/1562816414804fBZJAOVm.png",
    product_type: "",
    origin_amt: 800,
    least_amt: 480,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926208",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "紫金岁月·礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/50b31e595502a6abf0bf9421cfc8b483.png",
    product_type: "",
    origin_amt: 900,
    least_amt: 540,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926209",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "哥特少女·礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/50b31e595502a6abf0bf9421cfc8b483.png",
    product_type: "",
    origin_amt: 1800,
    least_amt: 1080,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926270",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "海派甜心·礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/add4e81843b8ae507245f61ae255bef2.png",
    product_type: "",
    origin_amt: 1800,
    least_amt: 1080,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926271",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "漫天蓝心·尾巴",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/b68e244e5e522256f8bafaa4fc33f1ba.png",
    product_type: "",
    origin_amt: 3000,
    least_amt: 1800,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926273",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "不羁学者·金刘海",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/1f6a65ccaeaaf9776e73799b728c3944.png",
    product_type: "",
    origin_amt: 800,
    least_amt: 480,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926276",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "儒雅学士·蓝礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/11b8a96b26dc51b241375c5bc7755a29.png",
    product_type: "",
    origin_amt: 1800,
    least_amt: 1080,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926280",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "阳光绅士·黑礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/74b64298a1d7e024a04ddc14efa6a2f4.png",
    product_type: "",
    origin_amt: 1800,
    least_amt: 1080,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926287",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "清新自然·绿礼服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/dd85163c1c07aef31d26f9d207ccf2c3.png",
    product_type: "",
    origin_amt: 1800,
    least_amt: 1080,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926288",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "不羁学者·笔记本",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/aa7c6247e7982ebc784b4bf8b857e210.png",
    product_type: "",
    origin_amt: 900,
    least_amt: 540,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926302",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "阳光绅士·笔记本",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/ef13849bff6cd734cc50fd8f46c58655.png",
    product_type: "",
    origin_amt: 900,
    least_amt: 540,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926306",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "黑色头发",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/ced8b67b1813c136dec5b3bf6b5145cf.png",
    product_type: "",
    origin_amt: 300,
    least_amt: 180,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926311",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "紫发帽子",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/257a3a2bda11d414eed9d5b923c9a2bf.png",
    product_type: "",
    origin_amt: 600,
    least_amt: 360,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926312",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "粉发防风镜",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/8e72f6b1900ad68147ea69a14cfa277e.png",
    product_type: "",
    origin_amt: 800,
    least_amt: 480,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926315",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "薄荷款衣服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/d977f71465a5abd7c7b58fc4686b1c22.png",
    product_type: "",
    origin_amt: 900,
    least_amt: 540,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926317",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "蓝绿迷彩服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/ebd621e8b65967d1d6e5816b940e22f4.png",
    product_type: "",
    origin_amt: 1200,
    least_amt: 720,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926321",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "橙蓝迷彩服",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/7c0acf420141fd7eb5cafdaf4c3c0297.png",
    product_type: "",
    origin_amt: 1200,
    least_amt: 720,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_926325",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "蓝色武器",
    product_url: "https://midas.gtimg.cn/vmall/SH2019061015601545451486/78779f5d4b656acc0f94138abd405761.png",
    product_type: "",
    origin_amt: 900,
    least_amt: 540,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_941262",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "铠",
    product_url: "https://midas.gtimg.cn/store_config/1562815656509u3Ota98p.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_941263",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "阿轲",
    product_url: "https://midas.gtimg.cn/store_config/1562815646828XDAQdpfM.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_941265",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "蔡文姬",
    product_url: "https://midas.gtimg.cn/store_config/1562815619270q0nC5h39.png",
    product_type: "",
    origin_amt: 5880,
    least_amt: 1760,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_941268",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "凯-龙域领主",
    product_url: "https://midas.gtimg.cn/store_config/1562816104232sze1Gbg.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  },
  {
    allow_channel: "*",
    begin_time: "2019-07-01 00:00:00",
    end_time: "2019-07-30 01:59:59",
    service_code: "*",
    product_id: "IEGAMS-236670-289984_941269",
    product_num: "1",
    bargain_time: "+2H",
    product_name: "蔡文姬-蔷薇王座",
    product_url: "https://midas.gtimg.cn/store_config/1562816115930U8xT5a3L.png",
    product_type: "",
    origin_amt: 2880,
    least_amt: 1440,
    filter_info: ""
  }
]
